import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/itinerario", label: "Itinerario" },
  { to: "/checklist", label: "Bagaglio" },
  { to: "/diario", label: "Diario" },
  { to: "/mappa", label: "Mappa" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [loc.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/75 border-b border-[#1D3A4C]/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="navbar-brand"
          className="flex items-center gap-2.5 group"
        >
          <span
            className="w-9 h-9 rounded-full overflow-hidden bg-white shadow-sm ring-1 ring-[#1D3A4C]/10 group-hover:rotate-12 transition-transform duration-500"
            style={{
              backgroundImage: "url(/logo.png)",
              backgroundSize: "172%",
              backgroundPosition: "51% 23%",
            }}
          />
          <span className="font-display text-lg text-[#1D3A4C]">
            Elba <span className="text-[#D96C4A]">'26</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                  isActive
                    ? "bg-[#1D3A4C] text-white"
                    : "text-[#1D3A4C]/80 hover:text-[#1D3A4C] hover:bg-[#1D3A4C]/5"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <button
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          className="md:hidden w-10 h-10 rounded-full border border-[#1D3A4C]/15 flex items-center justify-center bg-white/70 backdrop-blur"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="md:hidden bg-white/95 backdrop-blur-xl border-t border-[#1D3A4C]/10"
        >
          <div className="px-6 py-4 flex flex-col gap-1">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={`nav-mobile-link-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-xl text-base transition-colors ${
                    isActive
                      ? "bg-[#1D3A4C] text-white"
                      : "text-[#1D3A4C] hover:bg-[#1D3A4C]/5"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
